import React from "react"
import styled from "styled-components"
import NumericalValue from "./NumericalValue"


function CurrencyValue(props) {
	return (
		<NumericalValue>{props.currency + (parseFloat(props.value)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</NumericalValue>
	)
}

export default CurrencyValue
